module.exports = '<svg width="16" height="32" viewBox="0 0 16 32"><path d="M15.663 22.033h-5.642V10.007h5.642c.595 0 .776-.443.403-.906L8.803.31c-.373-.465-.972-.383-1.347.078L.193 9.105c-.371.463-.192.902.403.902h5.418v12.026H.596c-.595 0-.776.425-.403.888l7.263 8.769c.375.465.972.379 1.347-.082l7.263-8.682c.373-.461.192-.892-.403-.892z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/expand-vertically-1.js
// module id = 1129
// module chunks = 14